/**
 * @TODO: MOVE THIS TO SPORTS-COMMON
 */
import formatToUnits from '@app/ui/sports-components/utils/formatToUnits';
import getCurrencySymbol from './getCurrencySymbol';

const forceLocale = (num, places) =>
    new Number(num).toLocaleString({}, { minimumFractionDigits: places });

const shortCurrency = (value, decimalPlaces = 0, currency = 'USD') => {
    const symbol = getCurrencySymbol(currency);
    const places = value < 1000 ? 0 : decimalPlaces;
    const [num, suffix] = formatToUnits(value, places);
    const localValue = forceLocale(num, places);
    return `${symbol}${localValue}${suffix}`;
};

export default shortCurrency;
